import { render, staticRenderFns } from "./CaseRelations.vue?vue&type=template&id=1759b234"
import script from "./CaseRelations.vue?vue&type=script&lang=js"
export * from "./CaseRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports